import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { LoginComponent } from './login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MxCommonsModule, MxLanguageTranslationModule } from 'mx-commons';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { SharedComponentModule } from 'src/app/shared/components/shared-component.module';
import { ConfigurationModule } from '../configuration/configuration.module';


@NgModule({
	declarations: [LoginComponent],
	imports: [
		HttpClientModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		MxCommonsModule,
		MxLanguageTranslationModule,
		ConfirmationPopoverModule,
		SharedComponentModule,
		ConfigurationModule
	],
	exports: [LoginComponent]
})
export class LoginModule { }
